export default __webpack_public_path__ + "static/media/wallpaper.69d84669.jpg";